export const addNewElements = (direction, elements, newElements) => {
  return direction === 'prev' ? [...newElements, ...elements] : [...elements, ...newElements]
}

const getNavigationStorageKey = nameOfElementsInContext => `navigation:${nameOfElementsInContext}`

export const saveNavigation = ({ nameOfElementsInContext, nameOfFiltersInContext, elements, filters }) => {
  const results = elements.results.map(element => ({ id: element.id, order: { name: element.order.name } }))

  sessionStorage.setItem(
    getNavigationStorageKey(nameOfElementsInContext),
    JSON.stringify({
      [nameOfElementsInContext]: { results, next: elements.next, previous: elements.previous },
      [nameOfFiltersInContext]: filters,
    })
  )
}

export const getSavedNavigation = (nameOfElementsInContext, currentId) => {
  const savedNavigation = JSON.parse(sessionStorage.getItem(getNavigationStorageKey(nameOfElementsInContext)))

  if (!savedNavigation?.[nameOfElementsInContext].results.some(element => element.id === currentId)) return null

  return savedNavigation
}
